<template>
    <div 
        class="lg:w-[470px] flex flex-col bg-white shadow border-2 rounded-lg p-3 sm:p-5 select-none cursor-pointer"
        :class="isSelected ? 'border-[#1EB26D]' : 'border-[#D8DEE8]'"
        @click="$emit('select-product', productData)"
    >
        <div>
            <div 
                class="rounded-full p-2 inline-flex items-center"
                :class="{'bg-[#E3FBE7]': isSelected}"
            >
                <div 
                    class="w-[20px] h-[20px] flex justify-center items-center border-2 rounded-full"
                    :class="isSelected ? 'border-[#1EB26D] bg-[#1EB26D]' : 'border-[#D8DEE8] bg-white'"
                >
                    <img 
                        src="/images/campaigns/version-two/quote-selected-icon.svg"
                        alt="Quote selected icon"
                    />
                </div>

                <span 
                    class="px-2 text-[14px] font-medium"
                    :class="isSelected ? 'text-[#1EB26D]' : 'text-[#959BB5]'"
                >
                    {{ isSelected ? $t('campaign_version_two.quote_selected') : '' }}
                </span>
            </div>
        </div>

        <p class="text-[17px] lg:text-[20px] font-bold text-[#2C2C4F]">
            {{ productData.brand }} {{ productData.model }}
        </p>

        <p
            v-if="productData.tagline"
            class="text-[14px] lg:text-[16px] font-semibold pt-2"
            :style="`color: ${getItemColor(quoteKey)}`">
            {{ productData.tagline }}
        </p>

        <div class="py-6 flex flex-1 justify-between items-center">
            <div class="pr-4">
                <QuoteCheckListItem
                    v-for="(point, index) in JSON.parse(productData.selling_points)"
                    :key="`selling-point-${index}`"
                    :text-content="point"
                    list-icon-type="bullet"
                    :color="getItemColor(quoteKey)"
                />
            </div>

            <div class="product-image-wrapper flex-shrink-0">
                <img 
                    :src="ensureImageSrcSlash(productData.image_url)"
                />
            </div>
        </div>

        <div v-if="productData.partner_id" class="flex justify-between items-center lg:pb-2">
            <img 
                :src="ensureImageSrcSlash(productData.partner.image_url)"
                class="partner-image"
                :alt="`${productData.partner.name} logo`"
            />

            <!-- <button class="bg-[#F7F9FC] text-[#108FE5] py-2 px-4 flex items-center rounded-full font-semibold leading-snug datasheet-btn">
                <img 
                    src="/images/campaigns/version-two/pdf-icon.svg"
                    alt="Pdf icon"
                />

                <span class="pl-2">
                    {{ $t('campaign_version_two.Datasheet') }}
                </span>
            </button> -->
        </div>
    </div>
</template>

<script>
import QuoteCheckListItem from "@/Components/Campaigns/QuoteCheckListItem";

export default {
    props: {
        quoteKey: {
            type: Number,
            required: true,
        },
        productData: {
            type: Object,
            required: true,
        },
        isSelected: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    components: {
        QuoteCheckListItem,
    },
    methods: {
        ensureImageSrcSlash(src) {
            return src[0] === "/" ? src : "/" + src;
        },
        getItemColor(index) {
            const hexColors = ['#1EB26D', '#108FE5', '#F6C407'];

            return hexColors[index % hexColors.length];
        },
    },
}
</script>

<style scoped>
.product-image-wrapper {
    position: relative;
    width: 120px;
    height: 200px;
}

.product-image-wrapper > img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 90%;
    width: auto;
    height: 90%;
    object-fit: cover;
}
.partner-image {
    max-width: 100px;
}

.datasheet-btn {
    font-size: 12px;
}

@media screen and (min-width: 1024px) {
    .product-image-wrapper {
        width: 160px;
        height: 210px;
    }

    .partner-image {
        max-width: 130px;
    }

    .datasheet-btn {
        font-size: 14px;
    }
}
</style>